<!-- 连中印记活动界面 -->
<style scoped>
    .monk-active::before{
        content: "";
        width:3rem;
        height:3rem;
        position: absolute;
        top: 5%;
        left: 48%;
        transform: translateX(-50%);
        border-radius: 50%;
        box-shadow: 0 0 .6rem .1rem yellow,0 0 .4rem yellow inset;
        animation: monk-circle 1.5s linear infinite alternate;
    }
    .monk-active::after{
        content: "";
        display: block;
        background: repeating-conic-gradient(rgba(0,206,255,0) 0deg, rgb(255, 255, 255) 15deg, transparent 30deg);
        mask-image: radial-gradient(rgba(0,0,0,1), rgba(255,255,255,0) 72%);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        /* animation: rays-rotate 10s linear infinite,rays-scale 1s linear infinite alternate; */
        animation: rays-rotate 20s linear infinite,monk-rays-scale 1s linear infinite alternate;
    }
    @keyframes monk-rays-scale{
		0%{
			width: 50%;
			height: 50%;
		}
		100% {
			width: 90%;
			height: 90%;
        }
	}
    .animal-active{
        transition: transform 1s cubic-bezier(.25, 1.15, .35, 3.08);
        transform:none;
    }
    .weather-active::after{
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background: url(@/assets/images/room/bac/border_style_2.png) no-repeat;
        background-size: 107rem 5.3rem;
        background-position: -0.4rem -1rem;
        z-index: 1;
        /* animation: border-style-2 2.5s steps(16) infinite; */
        animation: border-style-2 2s steps(20) infinite;
    }
    @keyframes border-style-2 {
        from{
            background-position:-0.4rem -1rem;
        }
        to{
            background-position:-107.25rem -1rem;
        }
    }
    @keyframes monk-circle {
        0% {
            box-shadow: 0 0 .6rem .1rem yellow,0 0 .4rem yellow inset;
        }
        100% {
            box-shadow: 0 0 .1rem .1rem yellow,0 0 .1rem yellow inset;
        }
    }
    .text-indent-2rem{
        text-indent: 2rem;
    }
    .get-card{
        left: 50%;
        top:50%;
        width: 5rem;
        transform:translate(-50%,-50%) rotate(0deg);
        animation: get-card-move 1s linear 1s,get-card-rotate 1s linear 1s;
    }
    .top.end .get-card{
        animation: get-card-move-top-end 1s linear 1s,get-card-rotate 1s linear 1s;
    }
    .bottom.end .get-card{
        animation: get-card-move-bottom-end 1s linear 1s,get-card-rotate 1s linear 1s;
    }
    .get-card.animal,.get-card.weather{
        box-shadow: 0 0 .8rem yellow;
    }
    .get-card.monk{
        width: 6rem;
    }
    @keyframes get-card-move-top-end {
        0%{
            width: 5rem;
            left: 50%;
            top:50%;
        }
        70%{
            width: 5rem;
        }
        100% {
            left: 100%;
            top: 0%;
            width: 0;
        } 
    }
    @keyframes get-card-move-bottom-end {
        0%{
            width: 5rem;
            left: 50%;
            top:50%;
        }
        70%{
            width: 5rem;
        }
        100% {
            left: 100%;
            top: 100%;
            width: 0;
        } 
    }
    @keyframes get-card-rotate {
        100% {
            transform: translate(-50%,-50%) rotate(1440deg); 
        }
    }
    @media (min-width:576px){
        .weather-active::after{
            background-size: 148.25rem 8rem;
        }
        @keyframes border-style-2 {
            from{
                background-position:-0.4rem -1rem;
            }
            to{
                background-position:-148.45rem -1rem;
            }
        }
    }
</style>
<style>
    
</style>
<template>
    <div class="">
        <!-- 印记功能没展开时的获得效果 -->
        <div v-if="isShowGetMark&&userInfo.mark>0" :class="{'animal':userInfo.markType==MARK_TYPE.animal,'monk':userInfo.markType==MARK_TYPE.monk,'weather':userInfo.markType==MARK_TYPE.weather}" class="d-flex flex-column flex-sm-row position-absolute align-items-center index-13 get-card rounded-3">
            <div v-if="userInfo.markType==MARK_TYPE.animal" class="animal-active rotate-y-180 transform-3d position-relative w-100 flex-grow-1">
                <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 fs-1 rotate-y-180 fw-bold d-flex justify-content-center align-items-center" :style="{background: 'url('+require('@/assets/images/room/bac/bg_style_1.jpg')+') no-repeat top left/100% 100%'}"></div>
                <img class="img-fluid position-relative h-xs-0 flex-grow-1 p-1 backface-hidden" :src="require('@/assets/images/room/bac/12animal/'+(userInfo.mark||1)+'.png')" alt="">
            </div>
            <template v-else-if="userInfo.markType==MARK_TYPE.monk">
                <div class="monk-active position-absolute w-100 h-100 bg-opacity-50 top-0 start-0"></div>
                <img class="img-fluid position-relative h-xs-0 flex-grow-1" :src="require('@/assets/images/room/bac/18monk/'+(userInfo.mark||1)+'.png')" alt="">
            </template>
            <template v-else-if="userInfo.markType==MARK_TYPE.weather">
                <img class="img-thumbnail img-fluid position-relative h-xs-0 flex-grow-1 rounded-3" :src="require('@/assets/images/room/bac/24weather/'+(userInfo.mark||1)+'.jpg')" alt="">
            </template>
        </div>
        <!-- 主面板 -->
        <div v-load v-if="isShowPanel" class="position-fixed bg-dark border border-3 border-secondary start-50 translate-middle top-50 rounded-5 me-sm-3 mt-sm-2 w-xs-22rem w-50rem h-30rem index-13 end-4rem">
            <!-- <div class="d-none d-sm-block position-absolute end-0 w-1rem h-2rem mt-1 start-100" style="background-repeat:no-repeat;background-position:left 1px,left bottom,1px 1px,1px bottom;background-image: linear-gradient(45deg,#212529 .55rem,transparent .55rem),linear-gradient(135deg,#212529 .55rem,transparent .55rem),linear-gradient(45deg,#6c757d 50%,transparent 50%),linear-gradient(135deg,#6c757d 50%,transparent 50%);background-size:100% 50%;"></div> -->
            <!-- 规则 -->
            <div v-if="isShowRule" class="d-flex flex-column flex-grow-1 mx-2 mx-sm-3 h-100">
                <div class="text-center position-relative text-light fw-bold py-2 border-bottom border-secondary">
                    <div class="position-absolute top-50 start-0 translate-middle-y" @click="isShowRule=false">
                        <i class="bi bi-arrow-left-circle me-1"></i>{{$t('personal.back')}}
                    </div>
                    <div class="position-absolute top-50 end-0 translate-middle-y" @click="isShowRule=false">
                        <i class="bi bi-x-octagon fs-5" @click="$emit('close')"></i>
                    </div>
                    <span class="fs-4">{{$t("room.continuousRule")}}</span>
                </div>
                <div class="flex-grow-1 text-light py-1 overflow-y-scroll">
                    <div class="fw-bold">{{$t("room.continuousRuleTitle")}}</div>
                    <div class="d-flex flex-column my-1">
                        <span class="text-info fw-bold"><i class="bi bi-dice-1 me-1"></i>{{$t("room.continuousRuleOneTitle")}}</span>
                        <span class="text-indent-2rem">{{$t("room.continuousRuleOneContent")}}</span>
                    </div>
                    <div class="d-flex flex-column my-1">
                        <span class="text-info fw-bold"><i class="bi bi-dice-2 me-1"></i>{{$t("room.continuousRuleTwoTitle")}}</span>
                        <span class="text-indent-2rem">{{ $t("room.continuousRuleTwoContent") }}</span>
                    </div>
                    <div class="d-flex flex-column my-1">
                        <span class="text-info fw-bold"><i class="bi bi-dice-3 me-1"></i>{{$t("room.continuousRuleThreeTitle")}}</span>
                        <span class="text-indent-2rem">{{$t("room.continuousRuleThreeContent")}}</span>
                    </div>
                    <div class="d-flex flex-column my-1">
                        <span class="text-info fw-bold"><i class="bi bi-dice-4 me-1"></i>{{$t("room.continuousRuleFourTitle")}}</span>
                        <span class="text-indent-2rem">{{$t("room.continuousRuleFourContent")}}</span>
                    </div>
                    <div class="d-flex flex-column my-1">
                        <span class="text-info fw-bold"><i class="bi bi-dice-5 me-1"></i>{{$t("room.continuousRuleFiveTitle")}}</span>
                        <span class="text-indent-2rem">{{$t("room.twelveAnimal")}}({{markOdds[0]}}%)、{{$t("room.eighteenMonk")}}({{markOdds[1]}}%)、{{$t("room.twentyfourWeather")}}({{markOdds[2]}}%)</span>
                    </div>
                </div>
            </div>
            <!-- 内容 -->
            <div v-else class="d-flex w-100 h-100">
                <div class="d-flex text-light text-vertical text-center">
                    <div @click="currRuleType=MARK_TYPE.animal" class="flex-grow-1 w-100 px-1 text-spacing-_1" :class="[currRuleType==MARK_TYPE.animal?'bg-warning text-primary fw-bold':'text-secondary']">{{$t("room.ordinary")}}</div>
                    <div @click="currRuleType=MARK_TYPE.monk" class="flex-grow-1 w-100 px-1 text-spacing-_1" :class="[currRuleType==MARK_TYPE.monk?'bg-warning text-primary fw-bold':'text-secondary']">{{$t("room.nightmare")}}</div>
                    <div @click="currRuleType=MARK_TYPE.weather" class="flex-grow-1 w-100 px-1 text-spacing-_1" :class="[currRuleType==MARK_TYPE.weather?'bg-warning text-primary fw-bold':'text-secondary']">{{$t("room.purgatory")}}</div>
                </div>
                <div class="d-flex flex-column flex-grow-1 mx-2 mx-sm-3">
                    <div class="d-flex justify-content-between align-items-center text-light fw-bold py-2 border-bottom border-secondary">
                        <div class="text-light" @click="isShowRule=true">
                            <i class="bi bi-file-earmark-text-fill me-1"></i>{{$t("room.rule")}}<span class="d-none d-sm-inline">{{$t("room.explain")}}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="fs-4" :class="{'text-secondary':currRuleType!=userInfo.markType}">{{currRuleType==MARK_TYPE.animal?$t("room.twelveAnimal"):currRuleType==MARK_TYPE.monk?$t("room.eighteenMonk"):$t("room.twentyfourWeather")}}</span>
                            <span v-if="currRuleType==userInfo.markType" class="rounded-pill small px-2 bg-secondary mx-2 text-warning">{{$t("room.effective")}}</span>
                            <span v-else class="rounded-pill small px-2 bg-warning mx-2" @click="setMarkType(false)">{{$t("room.clickActivate")}}</span>
                        </div>
                        <i class="bi bi-x-octagon fs-5" @click="$emit('close')"></i>
                    </div>
                    <div class="flex-grow-1 d-flex flex-column">
                        <div class="flex-grow-1 d-flex flex-column flex-sm-row">
                            <div class="d-flex justify-content-center align-items-center py-1 pb-2 py-sm-0">
                                <div class="position-relative fw-bold rounded-circle w-xs-4rem w-5rem d-flex justify-content-center align-items-center">
                                    <img class="img-fluid" src="@/assets/images/room/bac/mark_count.png" alt="">
                                    <span class="position-absolute fw-bold text-light start-50 translate-middle-x fs-5 pb-1">{{ currRuleType==userInfo.markType?(userInfo.mark||0):0 }}</span>
                                    <span class="position-absolute bottom-xs-0 top-sm-100 rounded-pill bg-info small px-1 lh-xs-sm translate-50-y-xs">{{$t("room.currProgress")}}</span>
                                </div>
                            </div>
                            <div class="flex-grow-1 d-flex flex-wrap position-relative">
                                <div :class="[currRuleType==MARK_TYPE.animal?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-1 p-sm-2 position-relative align-items-center" v-for="i in 12" :key="i">
                                    <div :class="[(userInfo.markType!=MARK_TYPE.animal||i>(userInfo.mark||0))?'':'animal-active']" class="rotate-y-180 transform-3d position-relative w-100 h-xs-0 flex-grow-1">
                                        <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 fs-1 rotate-y-180 fw-bold d-flex justify-content-center align-items-center" :style="{background: 'url('+require('@/assets/images/room/bac/bg_style_1.jpg')+') no-repeat top left/100% 100%'}"></div>
                                        <img class="img-sm-fluid position-relative h-xs-100 w-xs-100 flex-grow-1 p-1 backface-hidden" :src="require('@/assets/images/room/bac/12animal/'+i+'.png')" alt="">
                                    </div>
                                </div>
                                <div :class="[currRuleType==MARK_TYPE.monk?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-0 p-sm-2 position-relative align-items-center" v-for="i in 18" :key="i">
                                    <div :class="[(userInfo.markType!=MARK_TYPE.monk||i>(userInfo.mark||0))?'bg-dark index-1':'monk-active']" class="position-absolute w-100 h-100 bg-opacity-50 top-0 start-0"></div>
                                    <img class="img-sm-fluid position-relative h-xs-0 flex-grow-1" :src="require('@/assets/images/room/bac/18monk/'+i+'.png')" alt="">
                                </div>
                                <div :class="[currRuleType==MARK_TYPE.weather?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-1 p-sm-2 position-relative align-items-center" v-for="i in 24" :key="i">
                                    <div :class="[(userInfo.markType!=MARK_TYPE.weather||i>(userInfo.mark)||0)?'bg-dark index-1':'weather-active']" class="position-absolute w-100 h-100 bg-opacity-50 top-0 start-0"></div>
                                    <img class="img-sm-fluid position-relative h-xs-0 flex-grow-1" :src="require('@/assets/images/room/bac/24weather/'+i+'.jpg')" alt="">
                                </div>
                                <div v-show="currRuleType==userInfo.markType&&(userInfo.markType==MARK_TYPE.animal&&userInfo.mark==12||userInfo.markType==MARK_TYPE.monk&&userInfo.mark==18||userInfo.markType==MARK_TYPE.weather&&userInfo.mark==24)" class="position-absolute top-50 start-50 translate-middle">
                                    <i class="d-block fs-1 text-danger px-2 init-rotate-345 border border-3 border-danger rounded-5">{{$t("room.returned")}}</i>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-sm-center fw-bold py-2 border-top border-secondary position-relative">
                            <span @click="$emit('close')" class="d-none d-sm-block bg-secondary rounded-pill px-3 py-1 mx-1 mx-sm-3">{{$t("common.close")}}</span>
                            <span @click="setMarkType(true)" class="bg-danger rounded-pill px-3 py-1 mx-1 mx-sm-3">{{$t("room.resetProgress")}}</span>
                            <div class="d-flex align-items-center position-absolute end-0 top-50 translate-middle-y">
                                <span class="text-light me-1">{{$t("room.finalReturn")}}</span>
                                <span class="text-warning fs-3 fw-bold">{{markOdds[currRuleType-1]||0}}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {MARK_TYPE,LAYER_TYPE,COMMAND,RULE_TYPE,MUTATION_TYPE} from "@/assets/js/config.js"
import { useLayer } from '@/assets/js/useLayer';
export default{
    directives:{
        'load':{
            created(elem,binding) {
                let _this=binding.instance;
                //获取玩法配置信息
                // _this.$root.wsSend(COMMAND.all_getrule,RULE_TYPE.mark, _this.userInfo.id,_this.userInfo.guid);
                _this.$root.wsSendJson({
                    command:COMMAND.all_getrule,
                    ruleType:RULE_TYPE.mark,
                    userid:_this.userInfo.id,
                    guid:_this.userInfo.guid
                });
            },
        }
    },
    props:{
        //是否显示活动主面板
        isShowPanel:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            MARK_TYPE,
            isShowRule:false,//是否显示规则说明
            currRuleType:1,//玩家当前显示的玩法（1:十二生肖 2:十八罗汉 3:二十四节气）
            markOdds:[],//印记玩法返利
            activeRuleType:0,//玩家当前已激活的玩法
            isShowGetMark:false,//是否显示得到印记动画
        }
    },
    computed:{
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
    },
    unmounted(){
        delete this.$root.wsMsgObj["taskMark"];
    },
    mounted() {
        this.$root.wsMsgObj["taskMark"]=(data)=>{
            switch (data.command) {
                case COMMAND.all_getrule:
                    if(data.type==RULE_TYPE.mark){
                        this.markOdds=[data.z12,data.z18,data.z24];
                    }
                    break;
                case COMMAND.all_setruletype:
                    if(data.result==1){//成功
                        let mark=0;//默认重置进度
                        if(data.type>this.userInfo.markType){//升级需要继承进度
                            mark=this.userInfo.mark;
                        }
                        this.$store.commit({
                            type:MUTATION_TYPE.setUserInfo,
                            userInfo:{
                                markType:data.type==0?this.userInfo.markType:data.type,
                                mark:mark
                            }
                        })
                        this.activeRuleType=this.currRuleType;
                    }else{
                        useLayer({str:this.$t("room.activationFailed")});
                    }
                    break;
                case COMMAND.all_getgain:
                    if(data.win!=0||data.lose!=0){
                        if(data.win-data.lose>0&&!this.isShowPanel){//赢了并且没点开印记界面则显示获得印记效果
                            this.isShowGetMark=true;
                            setTimeout(() => {
                                this.isShowGetMark=false;
                            }, 2000);
                        }
                    }
                    break;
            }
            
        }
    },
    methods: {
        /**
         * 设置印记类型
         */
        setMarkType(isReset){
            if(isReset){//重置进度
                if(this.userInfo.mark==0){
                    useLayer({str:this.$t("room.unReset")});
                    return;
                }
                useLayer({type:LAYER_TYPE.confirm,str:this.$t("room.resetConfirm"),btn:[this.$t("room.clear"),this.$t("room.forget")],yesFn:()=>{
                    // this.$root.wsSend(COMMAND.all_setruletype,RULE_TYPE.mark,0,this.userInfo.id,this.userInfo.guid);
                    this.$root.wsSendJson({
                        command:COMMAND.all_setruletype,
                        ruleType:RULE_TYPE.mark,
                        ruleMode:0,
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    });
                }})
            }else{
                if(this.currRuleType>this.userInfo.markType&&this.userInfo.markType!=0){//当前希望升级
                    useLayer({type:LAYER_TYPE.confirm,str:this.$t("room.upgradeConfirm"),btn:[this.$t("room.upgrade"),this.$t("room.forget")],yesFn:()=>{
                        // this.$root.wsSend(COMMAND.all_setruletype,RULE_TYPE.mark,this.currRuleType,this.userInfo.id,this.userInfo.guid);
                        this.$root.wsSendJson({
                            command:COMMAND.all_setruletype,
                            ruleType:RULE_TYPE.mark,
                            ruleMode:this.currRuleType,
                            userid:this.userInfo.id,
                            guid:this.userInfo.guid
                        });
                    }})
                }else if(this.currRuleType<this.userInfo.markType){//当前希望降级
                    if(this.userInfo.mark==0){//还没有印记随便变更难度
                        // this.$root.wsSend(COMMAND.all_setruletype,RULE_TYPE.mark,this.currRuleType,this.userInfo.id,this.userInfo.guid);
                        this.$root.wsSendJson({
                            command:COMMAND.all_setruletype,
                            ruleType:RULE_TYPE.mark,
                            ruleMode:this.currRuleType,
                            userid:this.userInfo.id,
                            guid:this.userInfo.guid
                        });
                    }else{//已有印记
                        useLayer({str:this.$t("room.unDegrade")});
                    }
                }
            }
        },
    },
    watch:{
        /**
         * 监听用户印记类型改变
         */
        "userInfo.markType"(newVal){
            this.currRuleType=newVal;
        }
    }
}
</script>